import { ApiCallPost } from '../Api_Module/Api_Config/ApiCall';

export const ConvertKitService = {
    /**
     * Subscribes an email to a specific ConvertKit form.
     * Uses the V3 public API (client-side safe).
     */
    subscribe: async (email: string, firstName?: string) => {
        const apiKey = import.meta.env.VITE_CONVERTKIT_API_KEY;
        const formId = import.meta.env.VITE_CONVERTKIT_FORM_ID;

        if (!apiKey || !formId) {
            console.warn('ConvertKit API Key or Form ID is missing.');
            return;
        }

        const url = `https://api.convertkit.com/v3/forms/${formId}/subscribe`;

        // Payload for V3 API
        const payload = {
            api_key: apiKey,
            email: email,
            first_name: firstName
        };

        try {
            // Using standard fetch here to avoid dependency on internal ApiCall wrapper if it adds custom Auth headers
            // that might confuse ConvertKit (though usually ignored). 
            // But let's stick to standard fetch for third-party APIs to be safe.
            const response = await fetch(url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(payload)
            });

            const data = await response.json();

            if (!response.ok) {
                console.error('ConvertKit Subscription Failed:', data);
            } else {
                console.log('ConvertKit Subscription Success:', data);
            }
            return data;
        } catch (error) {
            console.error('ConvertKit Error:', error);
        }
    }
};
